import ApplicationController from './application_controller'


class TalentPoolRejectFormController extends ApplicationController {
  connect () {
    const form = this.element

    $(form).submit(function (event) {
      event.preventDefault()
      const formData = new FormData(form)

      fetch('/candidates/cancellation_talent_pool_email', {
        method: 'POST',
        body: formData
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(I18n.t('something_goes_wrong'))
          }

          const selectedIds = formData.get('selected_ids')
          selectedIds.split(',').forEach(id => $(`tr[id=${id}]`).remove())
          $('.hidden-side-close').trigger('click')
        })
        .catch(error => {
          console.error(error)
        })
    })
  }
}

export default TalentPoolRejectFormController
